import { render, staticRenderFns } from "./active-variations.vue?vue&type=template&id=5f48db49&"
import script from "./active-variations.vue?vue&type=script&lang=js&"
export * from "./active-variations.vue?vue&type=script&lang=js&"
import style0 from "./active-variations.vue?vue&type=style&index=0&id=5f48db49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports